export default __webpack_public_path__ + "static/media/quick_play_logo.32dd0b17.png";